import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col gap-4" }

import CarouselComponent from "@/components/carousel/CarouselComponent.vue";
import { onMounted, ref } from "vue";
import ModalComponent from "@/components/ModalComponent.vue";
import GradientButton from "@/components/buttons/GradientButton.vue";
import { useUserStore } from "@/stores/userStore";
import EmptyModal from "@/components/modals/EmptyModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const showPaidModal = ref(false);
const showBlockScreenModal = ref(false);

onMounted(async () => {
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get("session_id");
  if (!sessionId) {
    return;
  }
  try {
    showBlockScreenModal.value = true;
    const userStore = useUserStore();
    await userStore.checkStripeSuccess(sessionId);
    showPaidModal.value = true;
  } catch (error) {
    console.log(error);
  } finally {
    showBlockScreenModal.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CarouselComponent),
    _createVNode(ModalComponent, {
      show: showPaidModal.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (showPaidModal.value = false))
    }, {
      header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createElementVNode("p", { class: "text-2xl font-semibold text-black" }, "Поздравляем", -1)
      ]))]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-brown text-lg font-medium" }, " Ваша подписка успешно оформлена ! ", -1)),
          _createVNode(GradientButton, {
            class: "min-h-14",
            "bg-color": "bg-brown-gradient",
            "hover-bg-color": "bg-orange-gradient",
            text: "Ок",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showPaidModal.value = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(EmptyModal, { show: showBlockScreenModal.value }, null, 8, ["show"])
  ], 64))
}
}

})